import { Component, OnInit } from '@angular/core';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, RouterLink, RouterLinkActive],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  title = 'Flua | Pré-Atendimento';

  ngOnInit(): void {
    console.log(
      `%c Flua Pré-Atendimento v${environment.version} `,
      'background:#8B45BC;color:#fff;font-weight:bold;padding:4px 8px;border-radius:4px;'
    );
    console.log(`%c API: ${environment.apiUrl}`, 'color:#626272;font-size:11px;');
  }
}
